"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingSessionVideoAvailability]] contains the video availability information.
 */

var MeetingSessionVideoAvailability = /*#__PURE__*/function () {
  function MeetingSessionVideoAvailability() {
    _classCallCheck(this, MeetingSessionVideoAvailability);

    /**
     * Indicates whether one or more remote video streams
     * are available for streaming. This can be used to decide whether or not to
     * switch the connection type to include video.
     */
    this.remoteVideoAvailable = false;
    /**
     * Indicates whether the server has a slot available for
     * this client's local video tile. If the client is already sending a local
     * video tile, then this will be true. This property can be used to decide
     * whether to offer the option to start the local video tile.
     */

    this.canStartLocalVideo = false;
  }
  /**
   * Returns whether the fields are the same as that of another availability object.
   */


  _createClass(MeetingSessionVideoAvailability, [{
    key: "equal",
    value: function equal(other) {
      return this.remoteVideoAvailable === other.remoteVideoAvailable && this.canStartLocalVideo === other.canStartLocalVideo;
    }
    /**
     * Returns a deep copy of this object.
     */

  }, {
    key: "clone",
    value: function clone() {
      var cloned = new MeetingSessionVideoAvailability();
      cloned.remoteVideoAvailable = this.remoteVideoAvailable;
      cloned.canStartLocalVideo = this.canStartLocalVideo;
      return cloned;
    }
  }]);

  return MeetingSessionVideoAvailability;
}();

exports.default = MeetingSessionVideoAvailability;